import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

// Goes back one page when there is an in-app page to return to. When this page is the
// first one in the app's history (opened from a link, a refresh, a payment redirect or a
// fresh WebView start), navigate(-1) would do nothing or leave the app, so go to `fallback`.
export default function useGoBack(fallback = "/home") {
  const navigate = useNavigate();
  return useCallback(() => {
    // React Router stores the position in its own history stack as `idx`
    const index = window.history.state?.idx ?? 0;
    if (index > 0) navigate(-1);
    else navigate(fallback, { replace: true });
  }, [navigate, fallback]);
}
